import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
  t: (k) => k
});

const STORAGE_KEY = 'rk-lang';

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'hi' || stored === 'en' ? stored : 'en';
    } catch {
      return 'en';
    }
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const t = useCallback((key, ...args) => {
    const dict = translations[lang] || translations.en;
    const value = dict[key];
    if (value === undefined) {
      // Fallback to English dictionary
      const fallback = translations.en[key];
      if (fallback === undefined) return key;
      return typeof fallback === 'function' ? fallback(...args) : fallback;
    }
    return typeof value === 'function' ? value(...args) : value;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
